import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { Auth } from '../../../services/auth';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPassword {
  private dialogRef = inject(MatDialogRef<ForgotPassword>);
  private authService = inject(Auth);
  private toastr = inject(ToastrService);
  forgotPasswordForm = new FormGroup({
    usernameOrEmail: new FormControl('', [Validators.required])
  });

  onSubmit() {
    if (this.forgotPasswordForm.valid) {
      const value = this.forgotPasswordForm.value.usernameOrEmail!;

      this.authService.requestPasswordReset(value).subscribe({
        next: () => {
          this.toastr.success('Jelszó visszaállítási email küldve!', 'Sikeres művelet');
          this.dialogRef.close();
        },
        error: (error) => {
          this.toastr.error(error.error?.message || 'Hiba történt az igénylés során!', 'Hiba');
        }
      });
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
